/* eslint-disable prefer-destructuring */
import {
  ValidatorFn, AbstractControl, ValidationErrors, Validators
} from '@angular/forms';

export class AtLeastOneValidator {
  static of(keys: string[], error: ValidationErrors): ValidatorFn {
    const required = Validators.required;

    return (c: AbstractControl): ValidationErrors | null => {
      const root = c.root;
      const isPresent = keys.reduce(
        (exists: boolean, key: any) => exists || required(root.get(key)) === null,
        false
      );

      return isPresent ? null : error;
    };
  }
}
